export default __webpack_public_path__ + "static/media/icon-alert.99627b14.svg";